<template lang="pug">
.form-delivery.center
  h3 Observaciones
  .observations-container
    .observation(v-for="(observation, index) in dataForm.observations" :key="observation.createdAt" v-if="observation")
      .observation-observation {{ index + 1 }}. {{ observation.observation }}
      div {{ dateTime(observation.createdAt) }}
      shNameUser(:dni="observation.createdBy")

  form(@submit.prevent="")
    .input-container
      textarea.input(v-model="observation" autocomplete="ño" rows="3" required)
      label.label(:class="{ show: observation }") Observación

    shActionButton(:isForm="true" :action="addObservation" text="Agregar Observación" textRunning="Agregando Observación" :normalColor="true")

  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container
        input.input(v-model="dataForm.nameRecipient" autocomplete="ño" :disabled="fillData" required)
        label.label(:class="{ show: dataForm.nameRecipient }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="nameRecipient" title="Name Recipient")

      shInputList(:dataForm="dataForm" :dataOriginal="dataOriginal" title="Phone Recipient" property="phonesRecipient" pattern="[0-9]{10}" :fillData="fillData" :required="1")

      .input-container
        textarea.input(v-model="dataForm.addressRecipient" autocomplete="ño" rows="3" :disabled="fillData" required)
        label.label(:class="{ show: dataForm.addressRecipient }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="addressRecipient" title="Address Recipient")

      .input-container
        input.input(v-model="dataForm.charge" autocomplete="ño" :disabled="fillData" required)
        label.label(:class="{ show: dataForm.charge >= 0 }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="charge" title="Charge")

      .input-container
        input.input(v-model.number="dataForm.replacementCharge" type="number" min="0" max="5000000" autocomplete="ño")
        label.label(:class="{ show: dataForm.replacementCharge >= 0 }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="replacementCharge" title="Replacement Charge")

    .divider

    .form-section
      .input-container.arrow
        select.select(v-model="dataForm.dniDeliveryMan" autocomplete="ño" property="dniDeliveryMan" @change="setNameDeliveryMan()")
          option(value="")
          option(v-for="user in users" :value="user.dni") {{ user.name }}
        label.label(:class="{ show: dataForm.dniDeliveryMan }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="nameDeliveryMan" title="Delivery Man")

    .divider

    .form-section
      .input-container.arrow
        select.select(v-model="dataForm.conveyor" autocomplete="ño" property="conveyor" :required="dataForm.deliveryTracking")
          option(value="")
          option(v-for="conveyor in conveyors" :value="conveyor") {{ conveyor }}
        label.label(:class="{ show: dataForm.conveyor }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="conveyor" title="Conveyor")

      .tracking-row
        .input-container
          input.input(v-model="dataForm.tracking" autocomplete="ño")
          label.label(:class="{ show: dataForm.tracking }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="tracking" title="Tracking")
        TrackDeliveryButton(:tracking="dataForm.tracking" :conveyor="dataForm.conveyor")

    .divider

    .form-section
      .input-container
        input.input(v-model.number="dataForm.cost" min="0" max="200000" type="number" autocomplete="ño" @blur="deleteSymbols")
        label.label(:class="{ show: dataForm.cost >= 0 }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="cost" title="Delivery Cost")

      .input-container(v-if="dataForm.estimatedCost !== null && dataForm.estimatedCost !== undefined && dataForm.estimatedCost !== ''")
        input.input(v-model.number="dataForm.estimatedCost" min="0" max="200000" type="number" autocomplete="ño" disabled)
        label.label(:class="{ show: dataForm.estimatedCost >= 0 }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="estimatedCost" title="Estimated Cost")

    .divider

    div(v-if="dataOriginal.createdBy")
      div
        span Created By {{ ' ' }}
        span
          shNameUser.line(:dni="dataOriginal.createdBy")
      div Created At {{ dateTime(dataOriginal.createdAt) }}

    .divider

    h3 Agregar Comprobante
    div
      input.input-file1(ref="$inputFile" type="file" @change="setFile" accept="image/*" multiple)
      shActionButton(:action="clickFileInput" text="Elegir Comprobantes" textRunning="Elegir Comprbantes" :normalColor="true")

    .images-files
      .image-file(v-for="(file, index) in images")
        .image-file-container
          img.image-file-image(:src="createURL(file)")
          .tag-delivery {{ imagesStatus[index] || 'Pendiente' }}

    div
      shActionButton(v-if="images.length" :action="uploadPhotos" text="Guardar Comprobantes")

    h3 Comprobantes de Entrega

    .center
      .images-files
        .image-file(v-for="(receipt, index) in dataForm.receipts" v-if="receipt")
          .image-file-container
            img.image-file-image(:src="`https://sahet-cdn.b-cdn.net/img/receipts/deliveries/${receipt}.jpg`" :alt="`comprobante${index + 1}`")
            shActionButton(:action="deleteImage" :params="[receipt, index]" text="Eliminar" textRunning="Eliminando" :mini="true")

    .divider

    div(v-if="dataOriginal.declinedBy")
      div
        span Declined By {{ ' ' }}
        span
          shNameUser.line(:dni="dataOriginal.declinedBy")
      div Declined At {{ dateTime(dataOriginal.declinedAt) }}

    .divider

    div(v-if="dataOriginal.inProgressBy")
      div
        span In Progress By {{ ' ' }}
        span
          shNameUser.line(:dni="dataOriginal.inProgressBy")
      div In Progress At {{ dateTime(dataOriginal.inProgressAt) }}

    .divider

    div(v-if="dataOriginal.deliveredBy")
      div
        span Delivered By {{ ' ' }}
        span
          shNameUser.line(:dni="dataOriginal.deliveredBy")
      div Delivered At {{ dateTime(dataOriginal.deliveredAt) }}
      div(v-if="dataOriginal.leftBuildingReception") Left in building reception

    .divider

    div(v-if="dataOriginal.paidBy")
      div
        span Paid By {{ ' ' }}
        span
          shNameUser.line(:dni="dataOriginal.paidBy")
      div Paid At {{ dateTime(dataOriginal.paidAt) }}

    .divider

    div(v-if="dataOriginal.collectedBy")
      div
        span Collected By {{ ' ' }}
        span
          shNameUser.line(:dni="dataOriginal.collectedBy")
      div Collected At {{ dateTime(dataOriginal.collectedAt) }}

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteDelivery")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gql from '@my/graphql'
import gqlDelivery from '@/graphql/delivery'
import gqlImage from '@/graphql/image'
import shDeleteButton from '@/components/elements/DeleteButton'
import shInputList from '@/components/elements/InputList'
import shNameUser from '@/components/elements/NameUser'
import TrackDeliveryButton from '@/components/elements/delivery/TrackDeliveryButton.vue'
import modals from '@my/store/modals'
import auth from '@my/authentication'

export default {
  name: 'FormDelivery',

  mixins: [mForm, mFilters, mDB],

  components: { shDeleteButton, shInputList, shNameUser, TrackDeliveryButton },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object,
    sendNotifications: Boolean
  },

  data () {
    return {
      dataForm: {
        status: '',
        delivery: '',
        order: '',
        location: '',
        deparment: '',
        nameRecipient: '',
        addressRecipient: '',
        phonesRecipient: [''],
        conveyor: '',
        tracking: '',
        cost: '',
        estimatedCost: '',
        nameDeliveryMan: '',
        dniDeliveryMan: '',
        charge: '',
        replacementCharge: '',
        receipts: []
      },
      resolver: 'delivery',
      key: 'delivery',
      gql: gqlDelivery,
      gqlImage: gqlImage,
      delete: ['delivery', 'order', 'change', 'status', 'location', 'department', 'nameRecipient', 'addressRecipient', 'phonesRecipient', 'charge', 'inProgressAt', 'inProgressBy', 'declinedAt', 'declinedBy', 'createdAt', 'createdBy', 'deliveredAt', 'deliveredBy', 'paidAt', 'collectedAt', 'collectedBy', 'observations', 'updatedAt', 'receipts', 'estimatedCost'],
      observation: '',
      images: [],
      imagesStatus: [],
      isUploading: false
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  methods: {
    async uploadPhotos () {
      const newImagesLength = this.images.length
      const oldImagesLength = this.dataForm && this.dataForm.receipts ? this.dataForm.receipts.length : 0

      if ((newImagesLength + oldImagesLength) > 3) {
        modals.showMessage({ message: `No se puede subir más de 3 imágenes por entrega`, type: 'error' })
        return
      }

      for (let i = 0; i < this.images.length; i++) {
        const image = this.images[i]

        try {
          this.$set(this.imagesStatus, i, 'Subiendo')
          const resizedImage = await this.resizeImage(image, 1500, 1500)
          const nameImage = await this.sendPhoto(resizedImage)
          this.$set(this.imagesStatus, i, 'Subido')
          this.dataForm.receipts.push(nameImage)
        } catch (error) {
          this.$set(this.imagesStatus, i, 'Error')
          console.log(error)
        }
      }
    },
    createURL (file) {
      return URL.createObjectURL(file)
    },
    clickFileInput () {
      this.$refs.$inputFile.click()
    },
    setFile (event) {
      const files = event.target.files || event.dataTransfer.files
      this.images = files
    },
    async sendPhoto (resizedImage) {
      const query = gqlImage.UPLOAD_IMAGE_DELIVERY
      const variables = { image: null, delivery: this.dataForm.delivery, token: auth.getToken() }

      const formData = new FormData()
      formData.append('operations', JSON.stringify({ query, variables }))
      formData.append('map', JSON.stringify({ 0: ['variables.image'] }))
      formData.append('0', resizedImage, 'entrega.jpg')

      const body = formData

      const response = await gql.mutate(query, variables, false, [], body)

      if (!response || !response.data || !response.data.uploadImageDelivery) throw new Error('Error desconocido en el servidor')
      return response.data.uploadImageDelivery
    },

    resizeImage (file, maxWidth, maxHeight) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        const reader = new FileReader()

        reader.onload = () => {
          const event = window.event

          image.onload = () => {
            let width = image.width
            let height = image.height

            if (width > maxWidth || height > maxHeight) {
              const aspectRatio = width / height

              if (width > height) {
                width = maxWidth
                height = width / aspectRatio
              } else {
                height = maxHeight
                width = height * aspectRatio
              }
            }

            const canvas = document.createElement('canvas')
            canvas.width = width
            canvas.height = height

            const context = canvas.getContext('2d')
            context.drawImage(image, 0, 0, width, height)

            canvas.toBlob((blob) => { resolve(blob) }, file.type, (error) => { reject(error) })
          }

          image.onerror = (error) => { reject(error) }

          image.src = event.target.result
        }

        reader.onerror = (error) => { reject(error) }

        reader.readAsDataURL(file)
      })
    },

    sendForm () {
      if (!this.fillData) {
        this.newDelivery()
      } else {
        this.updateDelivery()
      }
    },

    newDelivery () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateDelivery () {
      this.updateData(this.gql, this.resolver, this.key, this.sendNotifications)
    },

    deleteDelivery () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    setNameDeliveryMan () {
      if (!window.event.target.selectedIndex) {
        this.dataForm.nameDeliveryMan = ''
        return
      }
      this.dataForm.nameDeliveryMan = this.users[window.event.target.selectedIndex - 1].name
    },
    async addObservation () {
      const mutation = gqlDelivery.ADD_OBSERVATION
      const delivery = this.dataForm.delivery

      const response = await gql.mutate(mutation, { delivery, observation: this.observation })

      if (response) {
        modals.showMessage({ message: `Observación agregada` })
        this.observation = ''
      }
    },
    deleteSymbols () {
      const event = window.event
      event.preventDefault()
      const target = event.target
      const value = target.value
      this.dataForm.cost = parseInt(value.replace(/[^\d]/g, ''))
    },

    async deleteImage (name, index) {
      const mutation = gqlDelivery.DELETE_IMAGE
      const delivery = this.dataForm.delivery

      const response = await gql.mutate(mutation, { delivery, image: name })

      if (response) {
        modals.showMessage({ message: `Imagen Eliminada` })
        this.dataForm.receipts.splice(index, 1)
      }
    }
  },

  computed: {
    conveyors () {
      return this.$store.state.variables.conveyors
    },
    users () {
      return this.$store.state.variables.users
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    },

    images: {
      handler (newVal) {
        if (newVal && newVal.length > 3) {
          newVal.splice(3, newVal.length)
          console.log(newVal)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-delivery
  position relative

.observation
  display flex
  justify-content space-between

.observation-observation
  flex-basis 40%
  text-align left

.container-images-delivery
 display flex
 flex-wrap wrap
 gap 1em

.container-images-delivery > div
  display flex
  flex-direction column
  align-items center
  gap 1em

.container-images-delivery img
  max-width 50em

.input-file1
  display none

.images-files
  display inline-flex
  flex-wrap wrap
  gap 1em
  align-items end
  margin-top 1em
  width 100%
  max-width 50em

.image-file
  text-align center
  margin-bottom 1.5em
  flex-basis 30%

.image-file-container
  min-height 10em
  display flex
  width 100%
  flex-wrap wrap
  gap 1em

.image-file-image
  border-radius 1em
  width 100%
  align-self center

.tag-delivery
  background-color #e5e5e6
  align-self flex-end
  padding .3em .5em
  border-radius .5em

.tracking-row
  display flex
  align-items flex-end
  gap .75rem
  flex-wrap wrap

.tracking-row .input-container
  flex 1 1 14rem
  min-width 0
</style>



// WEBPACK FOOTER //
// src/components/pages/delivery/Form.vue